import { render, staticRenderFns } from "./importar_arquivo.vue?vue&type=template&id=4c4bad21"
import script from "./importar_arquivo.vue?vue&type=script&lang=js"
export * from "./importar_arquivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports